var _defs, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 937.49998 201.3688",
    id: "svg285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs279"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath80",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M 24.62,29.48 H 170.579 V 68.4 H 24.62 z"
  })))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata282"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-68.475365,20.810656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g74",
    transform: "matrix(7.6503635,0,0,-7.6503635,-201.09667,455.52675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g76",
    clipPath: "url(#clipPath80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g82",
    transform: "translate(149.0787,47.5818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0.261 0.056,0.525 0.17,0.795 0.112,0.269 0.277,0.516 0.495,0.742 0.216,0.226 0.491,0.412 0.821,0.56 0.329,0.148 0.711,0.222 1.146,0.222 0.433,0 0.807,-0.074 1.12,-0.222 C 4.065,1.949 4.325,1.763 4.534,1.537 4.742,1.311 4.898,1.064 5.002,0.795 5.107,0.525 5.158,0.261 5.158,0 z M 6.905,-3.699 C 6.626,-3.908 6.183,-4.155 5.576,-4.442 4.967,-4.728 4.178,-4.872 3.205,-4.872 2.214,-4.872 1.437,-4.624 0.873,-4.129 0.309,-3.634 0.017,-3.057 0,-2.397 h 8.701 v 0.625 c 0,1.025 -0.129,1.968 -0.39,2.827 C 8.051,1.915 7.664,2.653 7.152,3.27 6.64,3.886 6.009,4.368 5.263,4.715 4.516,5.063 3.648,5.236 2.658,5.236 1.668,5.236 0.782,5.058 0,4.702 -0.781,4.346 -1.441,3.873 -1.98,3.283 -2.518,2.692 -2.93,2.002 -3.217,1.211 -3.503,0.421 -3.647,-0.4 -3.647,-1.25 c 0,-0.973 0.152,-1.863 0.456,-2.671 0.304,-0.807 0.747,-1.498 1.329,-2.071 0.581,-0.573 1.29,-1.021 2.123,-1.342 0.834,-0.321 1.771,-0.482 2.814,-0.482 0.781,0 1.475,0.075 2.083,0.222 0.609,0.148 1.134,0.317 1.577,0.508 0.443,0.191 0.803,0.386 1.08,0.586 0.279,0.2 0.487,0.343 0.626,0.43 z m -41.524,-0.443 c -0.243,-0.174 -0.503,-0.326 -0.781,-0.456 -0.278,-0.13 -0.608,-0.196 -0.99,-0.196 -0.504,0 -0.873,0.161 -1.107,0.483 -0.235,0.321 -0.352,0.777 -0.352,1.367 v 4.82 h 3.153 V 4.82 h -3.153 V 8.094 H -41.6 V 4.82 h -1.934 V 1.876 h 1.934 v -4.611 c 0,-0.765 0.078,-1.459 0.234,-2.085 0.157,-0.625 0.417,-1.159 0.782,-1.602 0.364,-0.443 0.842,-0.79 1.432,-1.042 0.591,-0.251 1.321,-0.378 2.189,-0.378 1.389,0 2.675,0.469 3.856,1.407 z M -2.141,9.17 c -0.556,0.469 -1.172,0.799 -1.849,0.99 -0.678,0.191 -1.347,0.287 -2.007,0.287 -0.624,0 -1.237,-0.1 -1.836,-0.3 -0.599,-0.2 -1.133,-0.504 -1.603,-0.912 -0.469,-0.408 -0.846,-0.924 -1.132,-1.55 -0.287,-0.625 -0.431,-1.372 -0.431,-2.24 V 4.82 h -1.979 V 1.876 h 1.979 v -9.275 h 3.725 v 9.275 h 2.893 V 4.82 h -2.893 v 0.677 c 0,0.608 0.157,1.077 0.47,1.407 0.312,0.329 0.729,0.495 1.25,0.495 0.33,0 0.651,-0.052 0.964,-0.156 C -4.277,7.138 -3.99,6.99 -3.73,6.8 z M -18.628,-7.399 h 3.751 V 4.82 h -1.876 -1.875 z m -13.075,0 h 11.43 v 3.218 h -7.496 V 9.978 h -3.934 z M -53.133,0 c 0,0.261 0.056,0.525 0.169,0.795 0.113,0.269 0.278,0.516 0.495,0.742 0.217,0.226 0.491,0.412 0.821,0.56 0.33,0.148 0.712,0.222 1.146,0.222 0.434,0 0.808,-0.074 1.12,-0.222 0.313,-0.148 0.574,-0.334 0.782,-0.56 0.208,-0.226 0.365,-0.473 0.469,-0.742 0.104,-0.27 0.156,-0.534 0.156,-0.795 z m 6.904,-3.699 c -0.278,-0.209 -0.721,-0.456 -1.329,-0.743 -0.608,-0.286 -1.398,-0.43 -2.371,-0.43 -0.99,0 -1.767,0.248 -2.331,0.743 -0.565,0.495 -0.856,1.072 -0.873,1.732 h 8.701 v 0.625 c 0,1.025 -0.13,1.968 -0.39,2.827 -0.261,0.86 -0.648,1.598 -1.16,2.215 -0.512,0.616 -1.142,1.098 -1.889,1.445 -0.746,0.348 -1.615,0.521 -2.605,0.521 -0.99,0 -1.875,-0.178 -2.657,-0.534 -0.781,-0.356 -1.442,-0.829 -1.98,-1.419 -0.539,-0.591 -0.951,-1.281 -1.237,-2.072 -0.287,-0.79 -0.43,-1.611 -0.43,-2.461 0,-0.973 0.151,-1.863 0.456,-2.671 0.303,-0.807 0.746,-1.498 1.328,-2.071 0.582,-0.573 1.29,-1.021 2.123,-1.342 0.834,-0.321 1.772,-0.482 2.814,-0.482 0.782,0 1.476,0.075 2.084,0.222 0.608,0.148 1.134,0.317 1.577,0.508 0.442,0.191 0.803,0.386 1.08,0.586 0.278,0.2 0.487,0.343 0.626,0.43 z m -30.195,-3.7 h 3.751 l 0.443,11.281 3.804,-6.696 h 2.032 l 3.595,6.774 0.495,-11.359 h 3.934 l -0.808,17.377 h -3.752 l -4.428,-8.154 -4.533,8.154 h -3.726 z m 59.671,13.616 c -1.158,0 -2.114,0.956 -2.114,2.115 0,1.159 0.956,2.115 2.114,2.115 1.188,0 2.115,-0.927 2.115,-2.115 0,-1.159 -0.956,-2.115 -2.115,-2.115",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86",
    transform: "translate(49.5279,53.7339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 2.951,-3.907 4.702,-8.773 4.702,-14.051 0,-1.273 -0.103,-2.522 -0.3,-3.741 h 8.544 c 0.743,0 1.345,0.604 1.345,1.349 V 7.178 c 0,0.88 -0.829,1.531 -1.678,1.307 C 7.511,7.138 3.095,4.098 0,0",
    style: {
      fill: "#99d538",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90",
    transform: "translate(45.1255,35.9424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.196,1.218 -0.3,2.467 -0.3,3.741 0,5.277 1.752,10.144 4.702,14.051 C 1.307,21.89 -3.109,24.93 -8.211,26.276 -9.06,26.5 -9.889,25.85 -9.889,24.97 V 1.348 C -9.889,0.604 -9.286,0 -8.543,0 z",
    style: {
      fill: "#239de0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g94",
    transform: "translate(49.5279,53.7339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -2.951,-3.907 -4.702,-8.773 -4.702,-14.051 0,-1.273 0.103,-2.522 0.3,-3.741 h 8.804 c 0.197,1.219 0.3,2.468 0.3,3.741 C 4.702,-8.773 2.951,-3.907 0,0",
    style: {
      fill: "#1563a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetLife);
export default __webpack_public_path__ + "static/media/metLife.7f56bdeeb0bb2fef81e83db63844cae5.svg";
export { ForwardRef as ReactComponent };